import React from "react";
import cx from "classnames";
import { ButtonGroupProps } from "../Button/types";

const alignmentClasses = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
  between: "justify-between",
  around: "justify-around",
};

const spacingClasses = {
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-3",
  lg: "gap-4",
};

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  children,
  align = "left",
  spacing = "md",
  vertical = false,
  fullWidth = false,
  className,
}) => {
  return (
    <div
      className={cx(
        "flex",
        {
          "flex-col": vertical,
          "flex-row": !vertical,
          "w-full": fullWidth,
        },
        alignmentClasses[align],
        spacingClasses[spacing],
        className
      )}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && fullWidth && !vertical) {
          return React.cloneElement(child as React.ReactElement<any>, {
            fullWidth: true,
          });
        }
        return child;
      })}
    </div>
  );
};

export default ButtonGroup;